import { render, staticRenderFns } from "./VaimoTruncatedText.vue?vue&type=template&id=7e587f24&scoped=true&"
import script from "./VaimoTruncatedText.vue?vue&type=script&lang=js&"
export * from "./VaimoTruncatedText.vue?vue&type=script&lang=js&"
import style0 from "./VaimoTruncatedText.vue?vue&type=style&index=0&id=7e587f24&prod&lang=scss&scoped=true&"
import style1 from "./VaimoTruncatedText.vue?vue&type=style&index=1&id=7e587f24&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e587f24",
  null
  
)

export default component.exports